<template>
  <Report :product="product" :isDetailsVisible="!isLoggedIn">
    <template v-slot:callToAction>
      <BuyReport
        :product="product"
        class="d-none d-md-block"
        :hasCallToActionButton="false"
      />
    </template>

    <template v-slot:default>
      <BuyReport
        :product="product"
        class="d-md-none"
        :hasCallToActionButton="false"
      />
      <BTabs nav-class="small-tabs d-print-none" content-class="structure-tabs">
        <BTab :title="$t('report.creditInquiry.inquiry')">
          <div class="tab-container-medium" v-if="details">
            <Watermark :text="product.watermarkLabel" v-if="details.isSample" />
            <span class="tab-subheading">{{ $t('report.creditInquiry.privateInquiries.title') }}</span>
            <table class="table structure-table" v-if="details.privateEnquiries.length">
              <thead>
                <tr>
                  <th class="d-none d-xl-table-cell">
                    {{ $t('report.creditInquiry.labels.time') }}
                  </th>
                  <th class="d-none d-xl-table-cell">
                    {{ $t('report.creditInquiry.labels.requesterId') }}
                  </th>
                  <th class="d-none d-xl-table-cell">
                    {{ $t('report.creditInquiry.labels.requesterName') }}
                  </th>
                  <th class="d-none d-xl-table-cell">
                    {{ $t('report.creditInquiry.labels.legalReason') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in details.privateEnquiries" :key="index">
                  <td>
                    <span class="td-header d-block d-xl-none">
                      {{ $t('report.creditInquiry.labels.time') }}
                    </span>
                    {{ $date(item.date, 'withTime') }}
                  </td>
                  <td>
                    <span class="td-header d-block d-xl-none">
                      {{ $t('report.creditInquiry.labels.requesterId') }}
                    </span>
                    {{ item.requesterId }}
                  </td>
                  <td>
                    <span class="td-header d-block d-xl-none">
                      {{ $t('report.creditInquiry.labels.requesterName') }}
                    </span>
                    {{ item.requesterName }}
                  </td>
                  <td>
                    <span class="td-header d-block d-xl-none">
                      {{ $t('report.creditInquiry.labels.legalReason') }}
                    </span>
                    {{ item.legalReason }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="alert alert-default mb-7 mt-5" role="alert" v-else>
              {{ $t('report.emptyList') }}
            </div>
            <p class="table-caption">
              <span class="icon-info2 marker" />&nbsp;
              <span v-html="$t('report.creditInquiry.privateInquiries.hint')" />
            </p>

            <span class="tab-subheading">{{ $t('report.creditInquiry.legalInquiries.title') }}</span>
            <table class="table structure-table" v-if="details.institutionalEnquiries.length">
              <thead>
                <tr>
                  <th class="d-none d-xl-table-cell">
                    {{ $t('report.creditInquiry.labels.time') }}
                  </th>
                  <th class="d-none d-xl-table-cell">
                    {{ $t('report.creditInquiry.labels.companyRequesterId') }}
                  </th>
                  <th class="d-none d-xl-table-cell">
                    {{ $t('report.creditInquiry.labels.requesterName') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in details.institutionalEnquiries" :key="index">
                  <td>
                    <span class="td-header d-block d-xl-none">
                      {{ $t('report.creditInquiry.labels.time') }}
                    </span>
                    {{ $date(item.date, 'withTime') }}
                  </td>
                  <td>
                    <span class="td-header d-block d-xl-none">
                      {{ $t('report.creditInquiry.labels.requesterId') }}
                    </span>
                    {{ item.requesterId }}
                  </td>
                  <td>
                    <span class="td-header d-block d-xl-none">
                      {{ $t('report.creditInquiry.labels.requesterName') }}
                    </span>
                    {{ item.requesterName }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="alert alert-default mb-7 mt-5" role="alert" v-else>
              {{ $t('report.emptyList') }}
            </div>
            <p class="table-caption">
              <span class="icon-info2 marker" />&nbsp;
              <span v-html="$t('report.creditInquiry.legalInquiries.hint')" class="ignore-p" />
            </p>
          </div>
          <Spinner v-else />
        </BTab>
      </BTabs>
    </template>
  </Report>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Report from './Report';
import Watermark from './Watermark';
import Spinner from './Spinner';
import BuyReport from './BuyReport';
import { BTab, BTabs } from 'bootstrap-vue-next';

export default {
  props: ['product'],
  components: {
    BTabs,
    BTab,
    Report,
    Spinner,
    Watermark,
    BuyReport,
  },
  data: () => ({
    details: null,
  }),
  computed: {
    ...mapGetters('session', ['isLoggedIn']),
  },
  methods: {
    ...mapActions('product', ['getMyCreditInquiry']),
  },
  created() {
    this.getMyCreditInquiry()
      .then((details) => this.details = details);
  },
};
</script>
